import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
// import IP from "../../../images/IP_Image.png"
import IP from "../../../images/peck2.jpg";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { postRequestGlobal } from "../../../API/global";
import { Link } from "react-router-dom";
// import CircularProgress from '@mui/material/CircularProgress';
import pecock_vdo from "../../../images/peco.gif";
import Box from "@mui/material/Box";
import ph_logo from "../../../images/IFFFI_LOGO.png";
import ph_Nfdc from "../../../images/NFDC-Logo.png";
import TajMahal from "../../../images/Group 706.png";

const VerifyOtpVerification = ({
  otpValue,
  handleInputOtp,
  handleSubmitOtpVerification,
  errors,
  setShowForgetPasswordForm,
  email,
}) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(120);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let interval = null;
    if (countdown === 0) {
      setResendDisabled(false);
    } else if (resendDisabled) {
      interval = setInterval(() => {
        setCountdown((countdown) => countdown - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendDisabled, countdown]);

  const backtoprevious = async (e) => {
    setShowForgetPasswordForm(true);
  };

  const handleResendOtpSubmit = async (e) => {
    e.preventDefault();

    // const formErrors = validateValues(formData);
    // Check if there are any errors
    // if (Object.keys(formErrors).length > 0) {
    //     return;
    // }
    setLoading(true);
    try {
      const payload = {
        email: email,
      };
      const response = await postRequestGlobal("forgot/resetPassword", payload);

      // setShowForgetPasswordForm(false)
      //   const data = await response.json();
      // console.log("Response:", response);
      // Handle success or further actions here
      // alert('Otp has sent successfully!');
      // setAlertMessage('Otp has sent successfully!');
      setAlertMessage(response.message);
      setAlertSeverity("success");
      setAlertOpen(true);
      setResendDisabled(true);
      setCountdown(120);
    } catch (error) {
      console.error("Error: ", error);
      // Handle error or display error message
      // alert('Error submitting form. Please try again later.');
      // setErrors('Error submitting form. Please try again later.');
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          //  bgcolor="rgba(255, 255, 255, 0.1)" zIndex={1000}>
          bgcolor="#1c682c7d"
          zIndex={1000}
        >
          <img src={pecock_vdo} alt="Loading..." />
          {/* <CircularProgress /> */}
        </Box>
      )}
      <div className="container-fluid px-0 w-100 overflow-x-hidden position-absolute">
        <div className="row h-100">
          <div className="col-sm-12 col-md-12 col-lg-6 overflow-x-hidden h-100 response-phone">
            <img
              src={IP}
              className="mob-IP"
              alt="Indian Panorama"
              width="100%"
              height="100%"
            />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 second-box h-100 overflow-auto">
            <div className="logo-Phone">
              <a href={process.env.REACT_APP_HOME_URL}>
                <img
                  src={ph_logo}
                  className=""
                  alt="Indian Panorama"
                  width="85px"
                  height="auto"
                />
              </a>
              <img
                src={ph_Nfdc}
                className=""
                alt="Indian Panorama"
                width="85px"
                height="auto"
              />
            </div>
            <div className="container">
              <div className="row">
                {/* <p className='register me-3' style={{cursor:"pointer"}}><p onClick={backtoprevious}><b>Go to previous page</b></p></p> */}
                <div className="col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                <div className="col-sm-10 col-md-10 col-lg-10 col-xl-10">
                  <h1 className="verification_code_details">
                    Enter Verification Code
                  </h1>
                  {email ? (
                    <p className="otp_sent_message">
                      An OTP has been sent to your registered email address:{" "}
                      {email}
                    </p>
                  ) : (
                    ""
                  )}

                  <form>
                    <div className="otp_input">
                      <OtpInput
                        value={otpValue}
                        name="otp"
                        onChange={handleInputOtp}
                        numInputs={6}
                        separator={<span>&nbsp;&nbsp;</span>}
                        containerStyle={{ justifyContent: "space-between" }}
                        inputStyle={{
                          width: "40px",
                          height: "40px",
                          margin: "0 8px",
                          borderRadius: "9px",
                          border: "1px solid #1c5768",
                        }}
                        renderInput={(props) => <input {...props} />}
                        className="otp_code_details"
                      />
                    </div>
                    <p className="resend_text_details">
                      If you didn't receive code? &nbsp; &nbsp;
                      {/* <b type='submit' style={{ cursor: 'pointer' }} onClick={handleResendOtpSubmit}>Resend</b> */}
                      {/* <b type='submit' style={{ cursor: 'pointer' }} onClick={handleResendOtpSubmit} disabled={resendDisabled}>Resend {resendDisabled ? `(${countdown}s)` : ''}</b> */}
                      <button
                        className={`resend_button ${
                          resendDisabled ? "disabled" : ""
                        }`}
                        type="submit"
                        onClick={handleResendOtpSubmit}
                        disabled={resendDisabled}
                      >
                        <b>Resend</b> {resendDisabled ? `(${countdown}s)` : ""}
                      </button>
                      {/* <button type='submit' onClick={handleResendOtpSubmit}>Resend</button> */}
                    </p>
                    {/* <p className='Log_in'><Link to="/forget-password" className='back_to_log_in'>Back To Forget Password</Link></p> */}
                    {/* <p className='Log_in'><button className="btn btn-success" onClick={backtoprevious}>Back</button></p> */}
                    <div className="submit_details">
                      <button
                        className="submit"
                        type="submit"
                        onClick={handleSubmitOtpVerification}
                      >
                        Verify
                      </button>
                    </div>
                    <div className="text-center mt-3">
                      <button onClick={backtoprevious} className="log_in_now">
                        Go to previous page
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
              </div>
            </div>
            <div>
              <img
                src={TajMahal}
                className="tajmahal"
                alt="Tajmal image"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default VerifyOtpVerification;
